import request from '@/config/request.js'

const ApiHome = request.Home

function createManualMetricForm () {
  return {
    profitPerArea: null,
    renewRate: null,
    referralRate: null,
    refundRate: null
  }
}

export default {
  data () {
    return {
      visible: false,
      loading: false,
      scoreList: [],
      assessInfo: {},
      manualSavingMap: {},
      manualMetricForm: createManualMetricForm()
    }
  },
  computed: {
    summaryText () {
      const schoolYear = this.assessInfo.schoolYear || '--'
      const term = this.assessInfo.term || '--'
      const level = this.assessInfo.level || '--'
      return schoolYear + ' · ' + term + ' · ' + level + '级评分'
    }
  },
  methods: {
    init (row) {
      this.visible = true
      this.scoreList = []
      this.assessInfo = row ? Object.assign({}, row) : {}
      this.manualMetricForm = createManualMetricForm()
      if (row && row.id) {
        this.loadDetail(row.id)
      }
    },
    loadDetail (id) {
      this.loading = true
      ApiHome.zoneHealthGetById.call(this, { id: id }, res => {
        this.applyDetailData(res)
        this.loading = false
      }, () => {
        this.loading = false
      })
    },
    applyDetailData (res) {
      const detail = res && res.data ? res.data : res
      const assess = detail && detail.assess ? detail.assess : {}
      this.assessInfo = Object.assign({}, this.assessInfo, assess)
      this.scoreList = Array.isArray(detail && detail.scores)
        ? detail.scores.map(item => Object.assign({}, item))
        : []
      this.syncManualMetricForm(assess)
    },
    scoreSpanMethod ({ row, column, rowIndex }) {
      if (!row || !column || column.property !== 'dimensionName') return
      const current = row.dimensionName || ''
      const prev = this.scoreList[rowIndex - 1]
      if (prev && (prev.dimensionName || '') === current) {
        return { rowspan: 0, colspan: 0 }
      }
      let rowspan = 1
      for (let i = rowIndex + 1; i < this.scoreList.length; i++) {
        const next = this.scoreList[i]
        if ((next.dimensionName || '') === current) {
          rowspan++
        } else {
          break
        }
      }
      return { rowspan: rowspan, colspan: 1 }
    },
    formatPercentValue (value) {
      if (value == null || value === '') return '--'
      const num = Number(value)
      if (Number.isNaN(num)) return '--'
      const scaled = num * 100
      const fixed = scaled.toFixed(2)
      return fixed.replace(/\.?0+$/, '') + '%'
    },
    formatWeight (value) {
      return this.formatPercentValue(value)
    },
    formatPlainValue (value) {
      if (value == null || value === '') return '--'
      const num = Number(value)
      if (Number.isNaN(num)) return '--'
      const fixed = num.toFixed(2)
      return fixed.replace(/\.?0+$/, '')
    },
    isRawMetric (row) {
      const metricName = row && row.metricName ? String(row.metricName) : ''
      return metricName === '带班师生比' || metricName === '年利润坪效'
    },
    isManualMetric (row) {
      const metricName = row && row.metricName ? String(row.metricName) : ''
      return metricName === '年利润坪效' ||
        metricName === '综合续费率' ||
        metricName === '转介绍率' ||
        metricName === '退费率'
    },
    getManualMetricField (row) {
      const metricName = row && row.metricName ? String(row.metricName) : ''
      if (metricName === '年利润坪效') return 'profitPerArea'
      if (metricName === '综合续费率') return 'renewRate'
      if (metricName === '转介绍率') return 'referralRate'
      if (metricName === '退费率') return 'refundRate'
      return ''
    },
    syncManualMetricForm (assess) {
      const data = assess || {}
      const toNumberOrNull = (value) => {
        if (value === '' || value === null || value === undefined) return null
        const num = Number(value)
        return Number.isNaN(num) ? null : num
      }
      this.manualMetricForm = {
        profitPerArea: toNumberOrNull(data.profitPerArea),
        renewRate: data.renewRate == null ? null : toNumberOrNull((Number(data.renewRate) * 100).toFixed(2)),
        referralRate: data.referralRate == null ? null : toNumberOrNull((Number(data.referralRate) * 100).toFixed(2)),
        refundRate: data.refundRate == null ? null : toNumberOrNull((Number(data.refundRate) * 100).toFixed(2))
      }
    },
    formatMetricValue (value, row) {
      if (this.isRawMetric(row)) {
        return this.formatPlainValue(value)
      }
      return this.formatPercentValue(value)
    },
    formatThresholdValue (value, direction, row) {
      const text = this.formatMetricValue(value, row)
      if (text === '--') return '--'
      if (direction === 'LOW_BETTER') return '≤ ' + text
      if (direction === 'HIGH_BETTER') return '≥ ' + text
      return text
    },
    formatScore (value) {
      const num = Number(value)
      if (Number.isNaN(num)) return '--'
      return num.toFixed(1)
    },
    getCampusLevelDesc (score) {
      const num = Number(score)
      if (Number.isNaN(num)) return '--'
      if (num >= 90) return '优秀校区'
      if (num >= 75) return '健康校区'
      if (num >= 60) return '合格校区'
      return '待提升校区'
    },
    getMetricTagText (row) {
      if (!row || !row.direction) return ''
      return this.isManualMetric(row) ? '手动' : '自动'
    },
    getMetricTagType (row) {
      if (!row || !row.metricName) return 'info'
      return this.isManualMetric(row) ? 'warning' : 'success'
    },
    getManualInputPrecision (row) {
      return this.isRawMetric(row) ? 2 : 4
    },
    getManualDisplayPrecision (row) {
      const field = this.getManualMetricField(row)
      if (!field) return 0
      const max = this.isRawMetric(row) ? 2 : 4
      const value = this.manualMetricForm[field]
      if (value === '' || value === null || value === undefined) return 0
      const num = Number(value)
      if (Number.isNaN(num)) return 0
      const text = String(value)
      const idx = text.indexOf('.')
      if (idx < 0) return 0
      const decimals = text.length - idx - 1
      if (decimals <= 0) return 0
      return decimals > max ? max : decimals
    },
    getManualInputStep (row) {
      return this.isRawMetric(row) ? 0.01 : 0.0001
    },
    getManualInputValue (row) {
      const field = this.getManualMetricField(row)
      if (!field) return null
      const value = this.manualMetricForm[field]
      if (value === '' || value === null || value === undefined) return null
      const num = Number(value)
      return Number.isNaN(num) ? null : num
    },
    isManualSaving (row) {
      const field = this.getManualMetricField(row)
      return field ? !!this.manualSavingMap[field] : false
    },
    onManualMetricBlur (row) {
      this.submitManualMetric(row)
    },
    onManualMetricEnter (row) {
      this.submitManualMetric(row)
    },
    submitManualMetric (row) {
      const field = this.getManualMetricField(row)
      if (!field || !this.assessInfo || !this.assessInfo.id) return
      const inputValue = this.getManualInputValue(row)
      if (inputValue === null) return
      const payload = {
        id: this.assessInfo.id,
        profitPerArea: this.assessInfo.profitPerArea,
        renewRate: this.assessInfo.renewRate,
        referralRate: this.assessInfo.referralRate,
        refundRate: this.assessInfo.refundRate
      }

      const currentProfit = this.manualMetricForm.profitPerArea
      if (currentProfit !== '' && currentProfit !== null && currentProfit !== undefined) {
        payload.profitPerArea = Number(currentProfit)
      }

      const currentRenew = this.manualMetricForm.renewRate
      if (currentRenew !== '' && currentRenew !== null && currentRenew !== undefined) {
        payload.renewRate = Number(currentRenew) / 100
      }

      const currentReferral = this.manualMetricForm.referralRate
      if (currentReferral !== '' && currentReferral !== null && currentReferral !== undefined) {
        payload.referralRate = Number(currentReferral) / 100
      }

      const currentRefund = this.manualMetricForm.refundRate
      if (currentRefund !== '' && currentRefund !== null && currentRefund !== undefined) {
        payload.refundRate = Number(currentRefund) / 100
      }

      this.$set(this.manualSavingMap, field, true)
      ApiHome.zoneHealthUpdateManualMetrics.call(this, payload, res => {
        this.$set(this.manualSavingMap, field, false)
        this.applyDetailData(res)
        this.$message({
          message: '指标更新成功',
          type: 'success'
        })
      }, () => {
        this.$set(this.manualSavingMap, field, false)
      })
    },
    getScorePercent (row) {
      const score = Number(row && row.score)
      if (Number.isNaN(score)) return 0
      const percent = score
      if (percent < 0) return 0
      if (percent > 100) return 100
      return percent
    },
    getEvaluateLevel (row) {
      const metricValue = Number(row && row.metricValue)
      const excellentValue = Number(row && row.excellentValue)
      const passValue = Number(row && row.passValue)
      const direction = row && row.direction ? row.direction : ''
      if (
        Number.isNaN(metricValue) ||
        Number.isNaN(excellentValue) ||
        Number.isNaN(passValue)
      ) {
        return '待定'
      }
      if (direction === 'LOW_BETTER') {
        if (metricValue <= excellentValue) return '优秀'
        if (metricValue <= passValue) return '合格'
        return '待提升'
      }
      if (direction === 'HIGH_BETTER') {
        if (metricValue >= excellentValue) return '优秀'
        if (metricValue >= passValue) return '合格'
        return '待提升'
      }
      return '待定'
    },
    getEvaluateText (row) {
      return this.getEvaluateLevel(row)
    },
    getEvaluateTagType (row) {
      const text = this.getEvaluateLevel(row)
      if (text === '优秀') return 'success'
      if (text === '合格') return 'warning'
      return 'info'
    },
    getEvaluateClass (row) {
      const text = this.getEvaluateLevel(row)
      if (text === '优秀') return 'is-success'
      if (text === '合格') return 'is-warning'
      return 'is-default'
    }
  }
}
